<template>
  <div class="home" ref="menu" id="home">
    <div class="position-relative">
      <img src="../assets/home/1.png" alt="">
      <Header></Header>
      <div class="title-content">
        <div class="big-title animate__animated animate__fadeInDown">{{$t('home.title1')}}</div>
        <div class="small-title animate__animated animate__fadeInUp">{{$t('home.desc1')}}</div>
        <img class="animate__animated animate__bounceInUp" src="../assets/home/down.png" />
      </div>
    </div>
    <div class="introduce-wrapper">
      <div class="title-wapper">
        <div class="right-wrapper animate__animated animate__fadeInDown">
          <div class="title">{{$t('home.title2')}}</div>
        </div>
        <div class="left-wrapper animate__animated animate__fadeInDown">
          <p>{{$t('home.desc2_1')}}</p>
          <p>{{$t('home.desc2_2')}}</p>
        </div>
      </div>
    </div>
    <div class="productDrawing" id="oImg" ref="productDrawing">
      <div class="productWrapper">
        <img ref="imgDiv" src="../assets/home/2.png" alt="" :style="{ zoom:  `${zoom}%`}"/>
      </div>
    </div>
    <div class="serve-wrapper">
      <div class="serve-title animate__animated">{{$t('home.title3')}}</div>
      <div class="serve-desc animate__animated">{{$t('home.desc3')}}</div>
    </div>
    <accordion></accordion>
    <div class="master-wrapper position-relative" ref="masterWrapper">
      <img class="bg-img" src="../assets/home/3.png" alt="">
      <div class="master-content">
        <div class="slideInLeft1 top-content animate__animated">
          <div class="title">{{$t('home.title4')}}</div>
          <div class="tip-desc">{{$t('home.desc4')}}</div>
          <div class="line"></div>
        </div>
        <div class="swiper">
          <swiper></swiper>
        </div>
      </div>
    </div>
    <div class="advantage-wrapper position-relative">
      <img class="bg-img" src="../assets/home/4.png" alt="">
      <div class="advantage-content">
        <div class="advantage-left animate__animated">
          <div class="title">
            <div>OUR</div>
            <div>ADVANTAGE</div>
          </div>
        </div>
        <div class="advantage-right animate__animated">
          <div class="title">{{$t('home.advantage.title')}}</div>
          <div>
            <span class="first">{{$t('home.advantage.title1')}}：</span>
            <span class="seconde">{{$t('home.advantage.desc1')}} </span>
          </div>
          <div>
            <span class="first">{{$t('home.advantage.title2')}}：</span>
            <span class="seconde">{{$t('home.advantage.desc2')}}  </span>
          </div>
          <div>
            <span class="first">{{$t('home.advantage.title3')}}：</span>
            <span class="seconde">{{$t('home.advantage.desc3')}}  </span>
          </div>
          <div>
            <span class="first">{{$t('home.advantage.title4')}}：</span>
            <span class="seconde">{{$t('home.advantage.desc4')}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="number-wrapper position-relative" ref="numberWrapper">
      <img class="bg-img" src="../assets/home/5.png" alt="">
      <div class="number-content">
        <div>
          <div class="title">{{$t('home.number.title1')}}</div>
          <div class="number animate__animated">
            <countTo ref="countto1" class="countto" autoplay :startVal="1" :endVal="15860" :duration="2000" suffix="+"></countTo>
            <span>{{$t('home.number.desc1')}}</span>
          </div>
        </div>
        <div>
          <div class="title">{{$t('home.number.title2')}}</div>
          <div class="number animate__animated">
            <countTo ref="countto2" class="countto" autoplay :startVal="1" :endVal="126300" :duration="2000" suffix="+"></countTo>
            <span>{{$t('home.number.desc2')}}</span>
          </div>
        </div>
        <div>
          <div class="title">{{$t('home.number.title3')}}</div>
          <div class="number animate__animated">
            <countTo ref="countto3" class="countto" autoplay :startVal="1" :endVal="1650" :duration="2000" suffix="+"></countTo>
            <span>{{$t('home.number.desc3')}}</span>
          </div>
        </div>
        <div>
          <div class="title">{{$t('home.number.title4')}}</div>
          <div class="number animate__animated">
            <countTo ref="countto4" class="countto" autoplay :startVal="1" :endVal="129" :duration="2000" suffix="+"></countTo>
            <span>{{$t('home.number.desc4')}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="media-wrapper position-relative">
      <img class="bg-img" src="../assets/home/6.png" alt="">
      <div class="media-content">
        <div class="slideInLeft2 top-content animate__animated">
          <div class="title">{{ $t('home.title5') }}</div>
          <div class="tip-desc">{{ $t('home.desc5') }}</div>
          <div class="line"></div>
        </div>
        <div class="img-wrapper">
          <div>
            <img src="../assets/home/7.png" alt="">
          </div>
          <div>
            <img src="../assets/home/8.png" alt="">
          </div>
        </div>
      </div>
      <div class="media1 box animate__animated">
        <img src="../assets/home/ytb.png"/>
      </div>
      <div class="media2 box animate__animated">
        <img src="../assets/home/dy.png"/>
      </div>
      <div class="media3 box animate__animated">
        <img src="../assets/home/xhs.png"/>
      </div>
      <div class="media4 box animate__animated">
        <img src="../assets/home/xl.png"/>
      </div>
      <div class="media5 box animate__animated">
        <img src="../assets/home/wb.png"/>
      </div>
      <div class="media6 box animate__animated">
        <img src="../assets/home/zh.png"/>
      </div>
    </div>
    <div class="partner-wrapper position-relative">
      <div class="partner-top-wrapper">
        <div class="partner-title top-title animate__animated">{{ $t('home.title6') }}</div>
        <div class="partner-desc top-desc animate__animated">{{ $t('home.desc6') }}</div>
      </div>
      <div class="icon-content">
        <img class="partnerImg animate__animated" src="../assets/home/partner.png" />
      </div>
    </div>
    <Footer></Footer>
  </div>

</template>
<script>
import Accordion from "@/views/accordion";
import countTo from "vue-count-to";
import swiper from "@/components/swiper";
import Header from "@/components/header";
import Footer from "@/components/footer";
  export default {
    components: { Accordion, countTo, swiper, Header, Footer },
    data() {
      return {
        zoom: 50,
        currentScroll: 0,
        countto: true,
        imgHeight: '758px',
        oldScrollTop: null,
      }
    },
    methods: {
      handerImg() {
        const img = document.getElementById("oImg");
        this.imgHeight = img.offsetHeight || img.height || img.clientHeight;
        // 滚动条距文档顶部的距离
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
            document.body.scrollTop
        // 滚动条滚动的距离
        let scrollStep = scrollTop - this.oldScrollTop;
        // 更新——滚动前，滚动条距文档顶部的距离
        this.oldScrollTop = scrollTop;
        if (scrollStep < 0) {
          console.log("滚动条向上滚动了！", this.zoom)
          if (this.zoom > 50) {
            this.zoom = this.zoom - 2
            console.log('缩小')
          } else {
            this.zoom = 50
          }
        } else {
          console.log("滚动条向下滚动了！", this.zoom)
          if (this.zoom < 100) {
            this.zoom = this.zoom + 2
            console.log('放大')
          } else {
            this.zoom = 100
          }
        }
      },

      debounce(func, delay) {
        let timer = null;
        return function () {
          clearTimeout(timer);
          timer = setTimeout(() => {
            func.apply(this, arguments);
          }, delay);
        };
      },

      throttle(func, wait){
        let previous = 0;
        return function(){
          let now = Date.now(), context = this, args = [...arguments];
          if(now - previous > wait){
            func.apply(context, args);
            previous = now; // 闭包，记录本次执行时间戳
          }
        }
      },

      handleScroll() {
        // 页面滑动的距离
        this.currentScroll = window.pageYOffset
        if ((this.currentScroll > (this.$refs.productDrawing.offsetTop - 500)) && (this.currentScroll < this.$refs.productDrawing.offsetTop + 200)) {
          this.throttle(this.handerImg(), 2500)
        }
        if (this.currentScroll > (this.$refs.productDrawing.offsetTop + 200)) {
          if (this.zoom == 100) return
          this.zoom = 100
        }
        if (this.currentScroll < (this.$refs.productDrawing.offsetTop - 520)) {
          if (this.zoom == 50) return
          this.zoom = 50
        }
      }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll)
      const io = new IntersectionObserver(entries => {
        entries.forEach(item => {
          if (item.isIntersecting) {
            if (item.target.classList[0] == 'big-title') {
              item.target.classList.add('animate__backInDown')
            }
            if (item.target.classList[0] == 'advantage-left') {
              item.target.classList.add('animate__fadeInLeft')
            }
            if (item.target.classList[0] == 'advantage-right') {
              item.target.classList.add('animate__fadeInRight')
            }
            if (item.target.classList[0] == 'serve-title') {
              item.target.classList.add('animate__fadeInDown')
            }
            if (item.target.classList[0] == 'serve-desc') {
              item.target.classList.add('animate__fadeInUp')
            }
            if (item.target.classList[0] == 'slideInLeft1') {
              item.target.classList.add('animate__slideInLeft')
            }
            if (item.target.classList[0] == 'slideInLeft2') {
              item.target.classList.add('animate__slideInLeft')
            }
            // 计算
            if (item.target.classList[0] == 'number') {
              if (this.countto) {
                this.$refs.countto1.start()
                this.$refs.countto2.start()
                this.$refs.countto3.start()
                this.$refs.countto4.start()
                this.countto = false
              }
            }
            // 合作媒体
            if (item.target.classList[0] == 'media1') {
              item.target.classList.add('animate__zoomInRight')
            }
            if (item.target.classList[0] == 'media2') {
              item.target.classList.add('animate__zoomInUp')
            }
            if (item.target.classList[0] == 'media3') {
              item.target.classList.add('animate__zoomInLeft')
            }
            if (item.target.classList[0] == 'media4') {
              item.target.classList.add('animate__zoomInRight')
            }
            if (item.target.classList[0] == 'media5') {
              item.target.classList.add('animate__zoomInDown')
            }
            if (item.target.classList[0] == 'media6') {
              item.target.classList.add('animate__zoomInLeft')
            }
            if (item.target.classList[0] == 'partner-title') {
              item.target.classList.add('animate__fadeInDown')
            }
            if (item.target.classList[0] == 'partner-desc') {
              item.target.classList.add('animate__fadeInUp')
            }
            if (item.target.classList[0] == 'partnerImg') {
              item.target.classList.add('animate__zoomIn')
            }
          }
        })
      }, {})

      const nodeLists = [...document.querySelectorAll('.animate__animated')]
      nodeLists.forEach(box => {
        io.observe(box)
      })

    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>
<style lang="scss" scoped>
.title-content {
  width: 100%;
  position: absolute;
  top: 160px;
  left: 0;
  right: 0;
  z-index: 11;
  .big-title {
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
  }
  .small-title {
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 40px;
    color: #FFFFFF;
    line-height: 40px;
    margin-top: 40px;
  }
  img {
    width: 68px;
    height: 68px;
    margin-top: 80px;
  }
}

.zh {
  .big-title {
    font-size: 80px;
    line-height: 80px;
  }
  .small-title {

  }
}

.en {
  .big-title {
    font-size: 60px;
    line-height: 60px;
  }
}

.introduce-wrapper {
  //height: 376px;
  padding: 100px 0;
  display: flex;
  width: 60%;
  margin: 0 auto;
  font-family: Microsoft YaHei;
  align-items: center;
  .title-wapper {
    display: flex;
  }
  .right-wrapper {
    font-weight: bold;
    font-size: 48px;
    color: #424242;
    line-height: 40px;
    margin-right: 5%;
    margin-top: 10px;
  }
  .left-wrapper {
    flex: 1;
  }
  p {
    text-align: left;
    text-indent:40px;
    font-weight: 400;
    font-size: 20px;
    color: #73788C;
    line-height: 40px;
    word-wrap:break-word;
    margin: 0;
  }
}

.productDrawing {
  width: 100%;
  max-height: 976px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  .productWrapper {
    img {
      max-width: 100%;
      min-height: 100%;
    }
  }

}

.serve-wrapper {
  height: 281px;
  font-family: Microsoft YaHei;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .serve-title {
    font-weight: bold;
    font-size: 48px;
    color: #424242;
    line-height: 40px;
    margin-bottom: 40px;
  }
  .serve-desc {
    font-weight: 400;
    font-size: 27px;
    color: #424242;
    line-height: 40px;
  }
}

.master-wrapper {
  height: 980px;
  font-family: Microsoft YaHei;
  .master-content {
    position: absolute;
    width: 100%;
    z-index: 11;
    .top-content {
      width: 100%;
      height: 100%;
      text-align: start;
      padding-left: 10%;
      box-sizing: border-box;
      .title {
        font-weight: bold;
        font-size: 48px;
        color: #424242;
        line-height: 40px;
        margin-top: 136px;

      }
      .tip-desc {
        font-weight: 400;
        font-size: 27px;
        color: #424242;
        line-height: 40px;
        margin-top: 20px;
      }
      .line {
        width: 47px;
        height: 6px;
        margin-top: 30px;
        background: #E2273E;
      }
    }
    .swiper{
      width: 100%;
      box-sizing: border-box;
      margin: 65px 0px 0px 0px;
      padding-left: 10%;
      z-index: 11;
      height: 432px;
    }
  }
}

.bg-img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.advantage-wrapper {
  height: 652px;
  text-align: start;
  .advantage-content {
    //width: 80%;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 11;
    display: flex;
    justify-content: space-between;
    height: 100%;
    .advantage-left {
      width: 326px;
      font-family: Smartisan Compact CNS;
      font-weight: 800;
      color: #FFFFFF;
      display: flex;
      justify-content: center;
      align-items: center;
      .title {
        height: 88px;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        flex-direction: column;
      }
    }
    .advantage-right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      padding: 120px 0px;
      .title {
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #FFFFFF;
      }
      .first {
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #FFFFFF;
        background: linear-gradient(180deg, rgba(252,255,0,0.71) 0%, rgba(255,255,255,0.71) 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .seconde {
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
      }
    }
  }
}

.zh {
  .advantage-content {
    width: 80%;
  }
  .advantage-left {
    font-size: 52px;
    line-height: 52px;
  }
  .advantage-right {
    .title {
      font-size: 48px;
      line-height: 40px;
    }
    .first {
      font-size: 27px;
      line-height: 40px;
    }
    .seconde {
      font-size: 27px;
      line-height: 40px;
    }
  }
}
.en {
  .advantage-content {
    width: 84%;
  }
  .advantage-left {
    font-size: 30px;
    line-height: 30px;
  }
  .advantage-right {
    .title {
      font-size: 24px;
      line-height: 24px;
    }
    .first {
      font-size: 18px;
      line-height: 18px;
    }
    .seconde {
      font-size: 16px;
      line-height: 16px;
    }
  }
}

.number-wrapper {
  height: 328px;
  .number-content {
    padding: 0px 15%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 11;
    box-sizing: border-box;
    .title {
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 27px;
      color: #FFFFFF;
      text-align: start;
      margin-left: 10px;
      margin-bottom: 20px;
    }
    .number {
      font-family: Smartisan Compact CNS;
      font-weight: 800;
      color: #FFFFFF;
    }
  }
}

.zh {
  .number-wrapper {
    .number {
      font-size: 50px;
    }
  }
}
.en {
  .number-wrapper {
    .number {
      font-size: 42px;
    }
  }
}

.media-wrapper {
  height: 1105px;
  font-family: Microsoft YaHei;
  background: #060415;
  .media-content {
    position: absolute;
    z-index: 11;
    width: 100%;
    .top-content {
      width: 100%;
      height: 100%;
      text-align: start;
      padding: 0 10%;
      box-sizing: border-box;
      .title {
        font-weight: bold;
        font-size: 48px;
        color: #fff;
        line-height: 48px;
        margin-top: 132px;

      }
      .tip-desc {
        font-weight: 400;
        font-size: 27px;
        color: #fff;
        line-height: 27px;
        margin-top: 29px;
      }
      .line {
        width: 47px;
        height: 6px;
        margin-top: 42px;
        background: #E2273E;
      }
    }
    .img-wrapper{
      height: 450px;
      width: 100%;
      padding: 190px 10% 0 10%;
      box-sizing: border-box;
      display: flex;
      img {
        height: 450px;
      }
    }
  }
  .box {
    width: 300px;
    height: 300px;
    position: absolute;
    z-index: 99;
  }
  .media1 {
    top: 22%;
    right: 40%;
  }
  .media2 {
    top: 15%;
    right: 25%;
  }
  .media3 {
    top: 5%;
    right: 10%;
  }
  .media4 {
    top: 55%;
    right: 38%;
  }
  .media5 {
    top: 55%;
    right: 18%;
  }
  .media6 {
    top: 50%;
    right: 5%;
  }
}

.partner-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  .partner-top-wrapper {
    font-family: Microsoft YaHei;
    height: 326px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .top-title {
      font-weight: bold;
      font-size: 48px;
      color: #424242;
      line-height: 40px;
      margin-bottom: 40px;
    }
    .top-desc{
      font-weight: 400;
      font-size: 27px;
      color: #424242;
      line-height: 40px;
    }
  }
  .icon-content {
    width: 1399px;
    height: 545px;
    margin-bottom: 136px;
  }
}
</style>
